export default "<ion-icon\n  (click)=\"toggleBookmarkState()\"\n  tappable\n  [@bookmark]=\"bookmarkState\"\n  name=\"star-outline\"\n></ion-icon>\n"